exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-margin{\n    margin-top: 15px\n}\n\n.custom-color{\n    background-color: #f4f4f4\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/timesheets/charts/charts.component.css
// module id = ../../../../../src/app/timesheets/charts/charts.component.css
// module chunks = main